/**
 * Maps new task form fields to legacy Firestore fields for backward compatibility.
 * Existing pages (TaskDashboard, TaskDetail, Marketplace) read old field names.
 */

import type { NewTaskForm, TaskUniverse, TaskTimeline, TaskExperience } from '../constants/taskCreation';

const universeToCategory: Record<TaskUniverse, string> = {
  create: 'graphic',
  build: 'code',
  design: 'graphic',
  automate: 'infrastructure',
  learn: 'other',
  produce: 'graphic',
  manage: 'IT',
  market: 'other',
  entertain: 'other',
  brand: 'graphic',
  research: 'other',
  other: 'other',
};

const timelineToPriority: Record<TaskTimeline, string> = {
  asap: 'critical',
  'this-week': 'high',
  'this-month': 'medium',
  'no-rush': 'low',
  custom: 'medium',
};

const timelineToUrgency: Record<TaskTimeline, string> = {
  asap: 'immediate',
  'this-week': '24h',
  'this-month': 'this-week',
  'no-rush': 'flexible',
  custom: 'this-week',
};

const experienceToDifficulty: Record<TaskExperience, string> = {
  explorer: 'beginner',
  maker: 'intermediate',
  pro: 'advanced',
  expert: 'expert',
};

export function mapNewTaskToLegacy(form: NewTaskForm) {
  const universe = form.universe || 'other';
  return {
    category: universeToCategory[universe as TaskUniverse] || 'other',
    priority: timelineToPriority[form.timeline] || 'medium',
    urgency: timelineToUrgency[form.timeline] || 'this-week',
    difficulty: experienceToDifficulty[form.experience] || 'intermediate',
    summary: form.goal,
    requirements: form.description,
    acceptanceCriteria: form.goal,
    aiToolsUsed: form.tools.map(t => t.name),
    relatedLinks: form.links,
    tags: form.tags,
    impact: form.collabStyle === 'solo' ? 'personal' : form.collabStyle === 'team' ? 'team' : 'project',
    environment: 'production',
    riskLevel: 'low',
    dataSensitivity: form.visibility === 'public' ? 'public' : 'internal',
    securityReview: false,
    blocked: false,
    taskAge: 'new',
  };
}
